<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <Card
            iconclass="iconline mypage-title-icon"
            :page_title="page_title"
            >
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-center">LINEアカウント連携を解除します。よろしいですか？</p>
                    </div>
                    <div class="col-sm-12" v-if="error_message_val">
                        <p class="text-center text-red mb-0">{{ error_message }}</p>
                    </div>
                </div>
                <div class="row justify-content-center mb-4">
                    <div class="lineBtn longBtn"><div class="lineBtn__inner" v-on:click="lineUnlink">LINEアカウント連携解除</div></div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import { UNLINK_SOCIAL_ACCOUNT_TO_MEMBER } from '../../constants/line_unlink';
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: 'LINEアカウント連携解除',
            error_message: '',
            error_message_val: false
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            this.GetLoginUserMemberStatus();
        },
        /** ----------------------------------------------
         * LINE連携解除
         * ---------------------------------------------- */
        lineUnlink () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.mutate({
                mutation: UNLINK_SOCIAL_ACCOUNT_TO_MEMBER
            }).then(res => {
                this.$router.push({ path: '/mypage-line-setting-quit-complete' });
            }).catch(error => {
                if (error.graphQLErrors[0].message === 'LINEアカウント連携がありません。') {
                    this.error_message_val = true;
                    this.error_message = error.graphQLErrors[0].message;
                } else {
                    this.error_message_val = true;
                    this.error_message = this.$t("error.validation.systemError");
                }
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        /** ----------------------------------------------
         * マイページトップに戻るボタン処理
         * ---------------------------------------------- */
        BackMyPage: function (){
            // マイページトップ画面へ遷移
            this.$router.push({ path: '/mypage' });
        }
    }
}

</script>

<style scoped>
.sp_label{
    display: none;
}

@media screen and (max-width: 896px) {
    .mypage_mainwindow{
       width: 98%;
       margin: 0 auto;
       -ms-overflow-style: none;
       scrollbar-width: none;
    }

    .mypage_mainwindow::-webkit-scrollbar {
        display:none;
    }

    .sp_label {
        display: inline-block;
        min-width: 6rem;
        font-weight: 600;
    }

    .side_display_none{
        display: none;
    }

    @media screen and (max-width: 650px) {
        .display-table td{
            font-size: 14px;
        }
    }
}
</style>
